import PdpContentWell from './pdp-content-well';
import PdpImageWell from './pdp-image-well';
import PdpProductDescription from './pdpProductDescription';

export default class PDPWellProps {
  pdpImageWell: PdpImageWell | undefined;
  pdpContentWell: PdpContentWell | undefined;
  pdpProductDescription: PdpProductDescription | undefined;

  constructor(props: any) {
    this.pdpContentWell = props.pdpContentWell
      ? new PdpContentWell(props.pdpContentWell)
      : undefined;
    this.pdpImageWell = props.pdpImageWell
      ? new PdpImageWell(props.pdpImageWell)
      : undefined;
    this.pdpProductDescription = props.pdpProductDescription
      ? new PdpProductDescription(props.pdpProductDescription)
      : undefined;
  }
}
